import classNames from 'classnames'
import Slider from 'react-slick'
import parse from 'html-react-parser'
import { useTranslation } from 'next-i18next/pages'
import { ContactCtaProps } from './types'
import styles from './ContactCta.module.scss'
import { DESK_IMAGES } from './ContactCta.constants'
import { useRouter } from 'next/router'
import { Language } from 'types/language'
import { Heading, Img } from '@boltenergy-be/design-system'
import { isWeekend } from 'utils/dayjs'

const ContactCta = ({ avatarPublicId, className, description, title }: ContactCtaProps) => {
  // Next Router
  const { locale } = useRouter()

  // i18n
  const { t } = useTranslation('lookingForHelp')

  // Support availability
  const available = isWeekend() === false

  return (
    <section className={classNames('section', styles.contact, className)}>
      <div className="container">
        <div className={styles['contact-card']}>
          <div className={styles['image-background']}>
            <div className={styles['image-container']}>
              {avatarPublicId ? (
                <Img
                  className={styles.image}
                  publicId={avatarPublicId}
                  fill
                  alt=""
                  steps={300}
                  sizes="(max-width: 620px) 140px, (max-width: 920px) 170px, 205px"
                />
              ) : (
                <Slider
                  slidesToShow={1}
                  fade
                  dots={false}
                  infinite
                  autoplay
                  arrows={false}
                  autoplaySpeed={4000}
                  speed={1000}
                  draggable={false}
                  pauseOnHover={false}
                >
                  {DESK_IMAGES.map((imageUrl) => {
                    return (
                      <Img
                        key={imageUrl}
                        publicId={imageUrl}
                        fill
                        alt="Bolt Energie support"
                        className={styles.image}
                        steps={300}
                        sizes="(max-width: 620px) 140px, (max-width: 920px) 170px, 205px"
                      />
                    )
                  })}
                </Slider>
              )}
            </div>
          </div>
          <div className={styles.content}>
            <Heading as="h2" variant="h3">
              {parse(title)}
            </Heading>
            <p>{parse(description)}</p>
            <p className={styles['with-links']}>
              <a href="tel:028993300">02 899 33 00</a>{' '}
              {parse(
                locale === Language.DUTCH
                  ? 'of <a href="mailto:hallo@boltenergie.be">hallo@boltenergie.be</a>'
                  : 'ou <a href="mailto:bonjour@boltenergie.be">bonjour@boltenergie.be</a>'
              )}
            </p>
            <p className={styles.posttext}>
              {available
                ? t('available', 'We zijn vandaag bereikbaar tot 17:00')
                : t('unavailable', 'We zijn maandag bereikbaar vanaf 9:00')}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

ContactCta.defaultProps = {
  hasDarkBg: false
}

export default ContactCta
